export function LocationInfo({
    timezone = null,
    locationName = null,
    locationId, 
    latitude,
    longitude,
    // No default on purpose: an empty string is a value, and the reducer's
    // initial state is compared field by field against the keys it really sets.
    address,
    vacationRentalPlan,
    radius,
    shareData,
    isBarrierEnabled,
    barrierMode,
    isProtectOn,
    protectOnEnter,
    protectOnExit,
    protectScheduleEnabled,
    protectScheduleBegin,
    protectScheduleEnd,
    protectScheduleEnabledSince,

    interfaceType,
    hasClockins = false,
    allowsCustomization,
    hasReservations,
    hasParking = false,
    hasIntegrations = false,
    hasTriggers = false,
    hasPermanentInstallerAccess = false,
    isThereBrain = false,
    canAddUsersToGroup,
    canBuyInvitations,

    rooms,

    invitationUid,
    invitationData,
    locationPermission = null,
    isSuperguest,
    isNotificationActive,
    allowsRemoteClockins,

    canCreateSuperguests,
    invitationsAllowed,
    invitationsLeft,

    companyName,
    companyContactEmail,
    companyCIF,
    companyAdditionalInfo,
    hasProtectSubscription,

    showProtectLocation,

    videoUrl,
    videoName,

    uid
} = {}) {
    return {
        timezone,
        locationName,
        latitude,
        longitude,
        address,
        vacationRentalPlan,
        radius,
        shareData,
        locationId,
        isProtectOn,
        protectOnEnter,
        protectOnExit,
        protectScheduleEnabled,
        protectScheduleBegin,
        protectScheduleEnd,
        protectScheduleEnabledSince,
        interfaceType,
        hasClockins,
        allowsCustomization,
        hasReservations,
        hasParking,
        hasIntegrations,
        hasTriggers,
        hasPermanentInstallerAccess,
        isThereBrain,
        hasProtectSubscription,
        canAddUsersToGroup,
        canBuyInvitations,
        isBarrierEnabled,
        barrierMode,
        rooms,
        
        invitationUid,
        invitationData,
        locationPermission,
        isSuperguest,
        isNotificationActive,
        allowsRemoteClockins,
        
        canCreateSuperguests,
        invitationsAllowed,
        invitationsLeft,

        companyName,
        companyContactEmail,
        companyCIF,
        companyAdditionalInfo,

        // Local, derived field
        showProtectLocation,
        
        videoName,
        videoUrl,

        uid
    };
}